import { render, staticRenderFns } from "./ParticipantDetails.vue?vue&type=template&id=79c88732&scoped=true"
import script from "./ParticipantDetails.vue?vue&type=script&lang=js"
export * from "./ParticipantDetails.vue?vue&type=script&lang=js"
import style0 from "./ParticipantDetails.vue?vue&type=style&index=0&id=79c88732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c88732",
  null
  
)

export default component.exports